import { unsafeCoerce } from 'fp-ts/lib/function';

/** Checks whether a string is a valid enum member, and returns either that enum member or null. */
export const parseToEnum = <T extends object>(value: string, enumObject: T): T[keyof T] | null => {
  if (Object.values(enumObject).includes(value)) {
    return unsafeCoerce(value);
  } else {
    return null;
  }
};
